export const EntryAnimation = {
  from: {
    y: -30,
    opacity: 0,
    transition: {
      duration: 0.2,
    },
  },

  to: {
    y: 0,
    opacity: 1,
    transition: {
      duration: 0.2,
    },
  },
};
